


















































import CurrentAccount from '@/store/entities/finance/currentAccount';
import { Component, Vue } from 'vue-property-decorator';
import LoadBalance from './modals/loadBalance.vue';



@Component({
  components: { LoadBalance },
})
export default class AccountBalanceManagements extends Vue {
  search: string = "";
  isOpenModal:boolean=false;
  mockData:any[]=[];
  headers:any[]=[];
  breadcrumbsItems:any[]=[];
  currentAccounts: CurrentAccount[] = [];





  created() {
    
    this.getAllCurrentAccounts();

    (this.headers = [
      { text: 'Acente', align: 'start', filterable: false, value: 'agency' },
      { text: 'Kredi Limiti', value: 'creditLimit' },
      { text: 'Para Birimi', value: 'currency' },
      { text: 'Hesap Hareketleri', value: 'accountActivities' },

    ]),
      (this.mockData = [
        {
          agency: 'Kuyucu',
          creditLimit: '150',
          usedCredit: '50	',
          availableBalance: '30',
          currency: 'TRY',
        },
      ]);

    this.breadcrumbsItems = [
      { text: 'Ana Sayfa', disabled: false, href: '/#/main/home' },
      { text: 'Finans', disabled: true },
      { text: 'Hesap Bakiye Yönetimi', disabled: true },
    ];
  }


  async getAllCurrentAccounts() {
    await this.$store.dispatch({
      type: "agency/getAllCurrentAccounts",
    });

    this.currentAccounts = this.$store.state.agency.currentAccounts;
  }



  data() {
    return {
      page: 1,
    };
  }


  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getAllCurrentAccounts();
  }
}
